import React from 'react';
import BarComponent from './BarComponent';
import ChartLoading from './ChartLoading';
import { BAR_CHART, PIE_CHART, useChartData } from './config';
import PieComponent from './PieComponent';
import { useFitnessBar } from '../data';

const Fitness = ({ loading, fitness }) => {
  const { fitnessBar } = useFitnessBar();

  const pieData = useChartData({ data: fitness, type: PIE_CHART, label: '' });
  const barData = useChartData({ data: fitnessBar, type: BAR_CHART, label: 'Kesehatan' });
  // const barData = useStackedChartData({ data: fitnessBar });

  return (
    <>
      {loading ? <ChartLoading /> : <PieComponent data={pieData} />}
      {/* <hr />
      
      <BarComponent data={barData} /> */}
    </>
  );
}

export default Fitness;